const bg = {
  warnings: {
    cantLoadSources: 'не може да бъде заредена'
  },
  transformations: {
    GEOGRAPHIC: 'Географски',
    WEB_MERCATOR: 'Уеб Меркатор',
    BGS2005: 'БГС 2005',
    BG2005CAD: 'БГС 2005 Кадастрална',
    UTM35: 'UTM 35',
    UTM34: 'UTM 34',
    BG_703: '70 - Зона 3',
    BG_705: '70 - Зона 5',
    BG_707: '70 - Зона 7',
    BG_709: '70 - Зона 9',
    BG_3024: '30 - 24',
    BG_3027: '30 - 27',
    BG50324: '50 - 3,24',
    BG50327: '50 - 3,27',
    BG50621: '50 - 6,21',
    BG50627: '50 - 6,27'
  },
  general: {
    all: 'всички',
    open: 'отвори',
    close: 'затвори',
    zoom: 'увеличи',
    getCloser: 'Приближи',
    window: 'прозорец',
    web: 'уеб',
    map: 'карта',
    cant: 'не може',
    mark: 'Маркирай',
    height: 'Височина',
    width: 'Ширина',
    coordinates: 'Координати',
    copy: 'Копирай',
    in: 'в',
    searchAction1: 'Търсене',
    from: 'от',
    identify: 'Идентификация',
    draw: 'Изчертай',
    drawOnMap: 'Изчертай на картата',
    edit: 'Редактирай',
    errorOccured: 'Възникна грешка',
    remove: 'Премахни',
    add: 'Добави',
    file: 'Файл',
    alreadyExists: 'вече съществува'
  },
  drawing: {
    holdWhileDrawing: 'Изчертайте на картата'
  },
  widgetTitles: {
    legend: 'Легенда',
    print: 'Печат',
    layers: 'Слоеве'
  },
  table: {
    noData: 'Няма данни',
    noResults: 'Няма резултати',
    zoomToSelected: 'Приближи към избраните',
    searchResults: 'Резултати от търсене',
    filterFromMap: 'Филтрирай от картата',
    export: 'Експорт',
    more: 'Още...',
    loading: 'Зареждане...',
    from: 'от'
  },
  mosaic: {
    noWindowsOpen: 'Няма отворени прозорци',
    addWindow: 'Добавете прозорец'
  },
  widgetNames: {
    map: 'Карта',
    tables: 'Резултати от търсене',
    tools: 'Инструменти',
    coordList: 'Позициониране по координати'
  },
  featureViews: {
    noObjectToCreate: 'Няма обекти елементи за създаване',
    createNewRepairComp: 'Създаване на нови фирми за ремонти',
    notValidIp: 'Не е валидно IP',
    fieldIsRequired: 'Полето е задължително',
    fieldValueLen: 'Дължината на полето трябва да е по - малка от',
    mostRecentlyFilled: 'Последно напълнен',
    mostRecentlyEmptied: 'Последно изпразнен',
    type: 'Тип',
    emptFilled: 'Пълен/празен',
    full: 'Пълен',
    empty: 'Празен',
    temperature: 'Температура',
    navigateTo: 'Навигирай до',
    noCoordinates: 'Няма координати',
    latestActivity: 'Последна активност',
    objDeleted: 'Обектът е изтрит',
    notWorking: 'Не работи',
    nonStop: 'Денонощно',
    dayFree: 'Почивен ден',
    workTime: 'Работно време',
    fixErrors: 'Моля, оправете грешките',
    searchCompany: 'Потърсете фирма'
  },
  details: {
    attachmetTitle: 'Прикачени файлове',
    noData: 'Няма намерени прикачени файлове'
  },
  exportExtentSelector: {
    chooseFromMap: 'Избор от картата',
    addToCart: 'Добави в количката',
    mapImgChoice: 'Избор на карта / изображение',
    useMapExtent: 'Изполвай обхвата на картата',
    highHeightWarning: 'Височината на обхвата трябва да е по-малка от ',
    lowHeightWarining: 'Височината на обхвата трябва да е по-голяма от ',
    wideWidthWarning: 'Ширината на обхвата трябва да е по-малка от ',
    shortWidthWarning: 'Ширината на обхвата трябва да е по-голяма от '
  },
  days: {
    monday: 'Понеделник',
    tuesday: 'Вторник',
    wednesday: 'Сряда',
    thursday: 'Четвъртък',
    friday: 'Петък',
    saturday: 'Събота',
    sunday: 'Неделя'
  }
}
const en = {
  warnings: {
    cantLoadSources: "can't be loaded"
  },
  transformations: {
    GEOGRAPHIC: 'Географски',
    WEB_MERCATOR: 'Уеб Меркатор',
    BGS2005: 'БГС 2005',
    BG2005CAD: 'БГС 2005 Кадастрална',
    UTM35: 'UTM 35',
    UTM34: 'UTM 34',
    BG_703: '70 - Зона 3',
    BG_705: '70 - Зона 5',
    BG_707: '70 - Зона 7',
    BG_709: '70 - Зона 9',
    BG_3024: '30 - 24',
    BG_3027: '30 - 27',
    BG50324: '50 - 3,24',
    BG50327: '50 - 3,27',
    BG50621: '50 - 6,21',
    BG50627: '50 - 6,27'
  },
  featureViews: {
    noObjectToCreate: 'No objects to create',
    createNewRepairComp: 'Create new repair company',
    notValidIp: 'IP is not valid',
    fieldIsRequired: 'Field is required',
    fieldValueLen: 'Value length must be less then',
    mostRecentlyFilled: 'Most recently filled',
    mostRecentlyEmptied: 'Most recently emptied',
    type: 'Type',
    emptFilled: 'Full/Empty',
    full: 'Full',
    empty: 'Empty',
    temperature: 'Temperature',
    navigateTo: 'Navigate',
    noCoordinates: 'No coordinates',
    latestActivity: 'Latest activity',
    objDeleted: 'Object is deleted',
    notWorking: 'Closed',
    nonStop: 'Non stop',
    dayFree: 'Closed',
    workTime: 'Work schedule',
    fixErrors: 'Please, fix the errors',
    searchCompany: 'Search companies'
  },
  general: {
    all: 'all',
    open: 'open',
    close: 'close',
    getCloser: 'zoom',
    zoom: 'zoom',
    window: 'window',
    web: 'web',
    map: 'map',
    cant: "can't",
    mark: 'Mark',
    height: 'Height',
    width: 'Width',
    coordinates: 'Coordinates',
    copy: 'Copy',
    in: 'in',
    searchAction1: 'Search',
    from: 'from',
    identify: 'Identify',
    draw: 'Draw',
    drawOnMap: 'Draw on map',
    edit: 'Edit',
    errorOccured: 'Error occured',
    remove: 'Remove',
    add: 'Add',
    file: 'File',
    alreadyExists: 'already exists'
  },
  drawing: {
    holdWhileDrawing: 'Hold down while drawing'
  },
  widgetTitles: {
    legend: 'Legend',
    print: 'Print',
    layers: 'Layers'
  },
  table: {
    noData: 'No data',
    noResults: 'No results',
    zoomToSelected: 'Zoom to selected',
    searchResults: 'Search results',
    filterFromMap: 'Apply map extent filter',
    export: 'Export',
    more: 'More...',
    loading: 'Loading...',
    from: '/'
  },
  mosaic: {
    noWindowsOpen: 'There is no open widnow',
    addWindow: 'Add Window'
  },

  widgetNames: {
    map: 'Map',
    tables: 'Search results',
    tools: 'Tools',
    coordList: 'Position by coordinates'
  },
  details: {
    attachmetTitle: 'Attachments',
    noData: 'No attachments available'
  },
  exportExtentSelector: {
    chooseFromMap: 'Select from the map',
    addToCart: 'Add to cart',
    useMapExtent: 'Use map extent',
    mapImgChoice: 'Choose map / image',
    highHeightWarning: 'The height of the extent should be less then ',
    lowHeightWarining: 'The height of the extent should be more then ',
    wideWidthWarning: 'The width of the extent should be less then ',
    shortWidthWarning: 'The width of the extent should be more then '
  },
  days: {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday'
  }
}

const nlss = {
  bg: bg,
  en: en
} as {[key: string]: nlsType}

export const nls = {} as nlsType & {langKey: string}

export const setLanguage = (langKey: string) => {
  for (const key in nlss[langKey]) {
    ;(nls as any)[key] = (nlss as any)[langKey][key]
  }
  nls.langKey = langKey
}

export const extendNls = (appNlss: {[key: string]: nlsType}, appNls: any) => {
  for (const key in nls) {
    if (typeof (nls as any)[key] == 'object') {
      appNls[key] = {...(nls as any)[key]}
    } else {
      appNls[key] = (nls as any)[key]
    }
  }
  for (const key in appNlss[nls.langKey]) {
    if (typeof (appNlss as any)[nls.langKey][key] == 'object') {
      appNls[key] = {...(appNlss as any)[nls.langKey][key]}
    } else {
      appNls[key] = (appNlss as any)[nls.langKey][key]
    }
  }
}

export type nlsType = typeof en | typeof bg
